import { PickListDesignTokens } from '@primeuix/themes/types/picklist';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/picklist/index.ts
const pl = componentCommon.picklist;

export const PicklistTelekomDT: PickListDesignTokens = {
  root: {
    gap: t(pl.gap),
  },
  controls: {
    gap: t(pl.controls.gap),
  },
};
